import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from '@mui/material';

const RoundClosedCard = () => {
  return (
    <Card>
      <CardHeader
        title='ROUND CLOSED'
        titleTypographyProps={{ flex: '1 1 100%', variant: 'h6' }}
      />
      <Divider />
      <CardContent>
        <Typography>
          Round is closed. Unable to make picks this round.
        </Typography>
      </CardContent>
    </Card>
  );
};

export default RoundClosedCard;
